import React, { useCallback, useEffect } from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Slider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Cropper from "react-easy-crop";
import { RestartAlt, ZoomIn } from "@mui/icons-material";

const CropperPanel = ({
  imgSelected,
  setImgSelected,
  crop,
  setCrop,
  zoom,
  setZoom,
  getCroppedImage,
  checkFileError,
  editMode,
  handleEdit,
  setFiles,
  styles,
  theme,
  handleClose = () => {},
}) => {
  useEffect(() => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
  }, [imgSelected?.name]);

  const onCropComplete = useCallback(
    (_, croppedAreaPixels) => {
      if (imgSelected) {
        setImgSelected((prev) => ({ ...prev, croppedAreaPixels }));
      }
    },
    [imgSelected, setImgSelected]
  );

  const handleCropConfirm = async () => {
    const cropped = await getCroppedImage(
      imgSelected.src,
      imgSelected.croppedAreaPixels
    );

    if (editMode) {
      handleEdit({ ...imgSelected, src: cropped });
    } else {
      setFiles((prev) =>
        prev.map((f, i) =>
          i === imgSelected.index
            ? {
                ...f,
                src: cropped,
                name: imgSelected.name,
                error: false,
              }
            : f
        )
      );
    }

    setImgSelected(null);
  };

  return (
    <Paper sx={styles.cropperPanel}>
      <Typography variant="h6" gutterBottom>
        Configurações do Ícone
      </Typography>

      <Stack gap={1}>
        <Typography variant="subtitle2" gutterBottom>
          Pré-visualização:
        </Typography>
        <Box sx={styles.cropperContainer}>
          <Cropper
            objectFit="cover"
            cropSize={{ width: 200, height: 200 }}
            image={imgSelected.src}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            onCropChange={setCrop}
            onCropComplete={onCropComplete}
            onZoomChange={setZoom}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <ZoomIn fontSize="small" sx={{ ml: 1, mr: 1 }} />
          <Slider
            value={zoom}
            onChange={(_, v) => setZoom(v)}
            min={1}
            max={3}
            step={0.1}
          />
          <IconButton onClick={() => setZoom(1)}>
            <RestartAlt />
          </IconButton>
        </Box>

        <Typography variant="subtitle2" gutterBottom>
          Nome do Ícone:
        </Typography>
        <TextField
          value={imgSelected.name}
          onChange={(e) =>
            setImgSelected((prev) => ({ ...prev, name: e.target.value }))
          }
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.nativeEvent.isComposing) {
              e.preventDefault();
              if (!checkFileError(imgSelected.name)) handleCropConfirm();
            }
          }}
          sx={styles.textField}
          variant="outlined"
          size="small"
          error={checkFileError(imgSelected.name)}
          helperText={
            checkFileError(imgSelected.name) && "O nome do ícone é inválido!"
          }
        />
      </Stack>
      <Stack direction={"row"} sx={styles.actionButtons}>
        <Button
          variant="text"
          onClick={() => {
            if (editMode) {
              handleClose();
              return;
            }
            setImgSelected(null);
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="text"
          sx={{ color: theme.palette.text.primary }}
          disabled={checkFileError(imgSelected.name)}
          onClick={handleCropConfirm}
        >
          OK
        </Button>
      </Stack>
    </Paper>
  );
};
export default CropperPanel;
